import { render, staticRenderFns } from "./product-detail-route.vue?vue&type=template&id=05192b91&"
import script from "./product-detail-route.vue?vue&type=script&lang=js&"
export * from "./product-detail-route.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-route.vue?vue&type=style&index=0&id=05192b91&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports